import type { Employee } from '../types';

/** Ordem alfabética por nome (pt-BR), para listagens por setor. */
export function sortEmployeesByName(employees: Employee[]): Employee[] {
  return [...employees].sort((a, b) =>
    a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
  );
}

export function sortItemsByEmployeeName(items: Record<string, Employee[]>): Record<string, Employee[]> {
  const next: Record<string, Employee[]> = {};
  for (const key of Object.keys(items)) {
    next[key] = sortEmployeesByName(items[key]);
  }
  return next;
}
